import { Reducers } from '@sda/enums/store';
import { SDK } from './helpers/sdk';
import type { FirestoreClientData } from './interfaces';
import type { Product } from '@sda/interfaces/product';

/**
 * SDK Class to interact with Firestore Products.
 */
export class Products extends SDK<Product> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.PRODUCTS);

    this.collection = this.fsh.Schema.PublicProducts;
  }
}
